<template>
	<div :class="themeClass">
		<div class="embed-menu-wrapper" v-if="!loading && !showComingSoon">
			<div class="embed-menu-header">
				<h1>2ndKitchen Menu</h1>
				<div class="embed-menu-header-subtitle">
					2ndKitchen offers exclusive food menus and events from local
					partners!
				</div>
			</div>
			<slot v-if="hasUpcomingEvents">
				<h2>Upcoming Events</h2>
				<div class="embed-upcoming-events">
					<EmbedEventCard
						v-for="event in events"
						:key="event.id"
						:event="event"
					/>
				</div>
				<button
					class="embed-primary-button"
					@click="exploreEventsClicked"
				>
					Explore Events
				</button>
			</slot>
			<slot v-if="hasMenuItems">
				<h2>Food Menu</h2>
				<div class="embed-menu">
					<div class="embed-item" v-for="item in menu" :key="item.id">
						<h3>{{ item.name }}</h3>
						<div class="embed-item-description">
							{{ item.description }}
						</div>
						<div class="embed-item-bottom">
							<div class="embed-item-price">
								{{ item.price | currency }}
							</div>
							<div class="embed-item-restaurant">
								<i class="sk-icon-utensils-solid"></i>
								{{ item.restaurantName }}
							</div>
						</div>
					</div>
				</div>
			</slot>
			<button class="embed-primary-button" @click="orderClicked">
				Order Now
			</button>
		</div>
		<div
			class="embed-coming-soon-wrapper"
			v-if="!loading && showComingSoon"
		>
			<div class="embed-menu-header">
				<h1>2ndKitchen Menu Coming Soon!</h1>
				<div class="embed-menu-header-subtitle">
					2ndKitchen offers exclusive food menus and events from local
					partners!
				</div>
			</div>
			<h2>2ndKitchen Benefits</h2>
			<div class="embed-coming-soon-perks">
				<div class="embed-coming-soon-perk">
					<img src="/images/2k-menu.png" alt="Menu" />
					<h3>Exclusive Menus</h3>
				</div>
				<div class="embed-coming-soon-perk">
					<img src="/images/2k-delivery.png" alt="Delivery" />
					<h3>Free Delivery</h3>
				</div>
				<div class="embed-coming-soon-perk">
					<img src="/images/2k-coupon.png" alt="Promotions" />
					<h3>Special Promotions</h3>
				</div>
			</div>
			<button class="embed-primary-button" @click="comingSoonClicked">
				Learn More
			</button>
		</div>
	</div>
</template>

<style scoped>
.embed-theme,
.embed-theme-dark {
	background: var(--sk-embed-bg-primary);
}

.embed-menu-wrapper,
.embed-coming-soon-wrapper {
	max-width: 1000px;
	margin: 0 auto;
	padding: 40px 0;
}

.embed-coming-soon-wrapper {
	max-width: 455px;
}

.embed-menu-header {
	margin: 0 5px 50px 5px;
	margin-bottom: 50px;
	text-align: center;
}

.embed-menu-header h1 {
	margin-bottom: 8px;
	font-size: 24px;
}

.embed-menu-header-subtitle {
	font-size: 14px;
	color: var(--sk-embed-font-secondary);
}

h1,
h2,
h3 {
	font-weight: 600;
	color: var(--sk-embed-font-primary);
}

h2 {
	font-size: 18px;
	margin: 0 10px 30px 10px;
}

h3 {
	font-size: 16px;
}

.embed-menu,
.embed-upcoming-events {
	display: grid;
	grid-template-columns: 1fr 1fr;
	grid-column-gap: 17px;
	grid-row-gap: 10px;
	margin: 0 10px 30px 10px;
}

.embed-item {
	background: var(--sk-embed-bg-secondary);
	border-radius: 5px;
	border: 1px solid var(--sk-embed-border);
	padding: 20px;
	display: flex;
	flex-direction: column;
}

.embed-item h3,
.embed-item-description {
	margin-bottom: 15px;
}

.embed-item-price,
.embed-item-description,
.embed-item-restaurant {
	color: var(--sk-embed-font-secondary);
}

.embed-item-description {
	font-size: 12px;
}

.embed-item-price {
	font-size: 14px;
	font-weight: 600;
}

.embed-item-restaurant {
	font-size: 11px;
}

.embed-item-restaurant i {
	margin-right: 10px;
	color: var(--sk-embed-font-secondary);
}

.embed-item-bottom {
	margin-top: auto;
	display: flex;
	justify-content: space-between;
}

.embed-coming-soon-perks {
	margin-bottom: 30px;
}

.embed-coming-soon-perk {
	background: var(--sk-embed-bg-secondary);
	border-radius: 5px;
	border: 1px solid var(--sk-embed-border);
	padding: 15px;
	display: flex;
	align-items: center;
}

.embed-coming-soon-perk + .embed-coming-soon-perk {
	margin-top: 20px;
}

.embed-coming-soon-perk h3 {
	margin: 0 0 0 30px;
}

.embed-coming-soon-perk img {
	width: 70px;
	height: 70px;
}

.embed-primary-button {
	height: 50px;
	width: auto;
	display: inline-block;
	display: flex;
	justify-content: center;
	align-content: center;
	align-items: center;
	border-radius: 40px;
	color: var(--gR-white);
	background-color: var(--sk-embed-primary-button);
	box-shadow: 0px 2px 4px var(--sk-embed-primary-button-shadow);
	font-size: 14px;
	cursor: pointer;
	padding: 0 40px;
	margin: 0 auto;
}

.embed-primary-button:hover {
	color: var(--gR-white);
}

@media (max-width: 600px) {
	.embed-menu,
	.embed-upcoming-events {
		grid-template-columns: 1fr;
	}
}
</style>

<script>
import currencyFilterMixin from "@/mixins/currency-filter-mixin"
import loaderMixin from "@/mixins/loader-mixin"
import EmbedEventCard from "@/components/embed/EmbedEventCard.vue"

export default {
	name: "EmbedMenu",
	components: {
		EmbedEventCard
	},
	mixins: [currencyFilterMixin, loaderMixin],
	computed: {
		loading() {
			return this.$store.state.loading
		},
		showComingSoon() {
			return this.$store.state.business.is_active == 0
		},
		hasUpcomingEvents() {
			return this.events.length > 0
		},
		hasMenuItems() {
			return this.menu.length > 0
		},
		menu() {
			if (this.$store.state.menu) {
				const restaurants = this.$store.state.restaurants
				return this.$store.state.menu.map((item) => {
					let restaurantName = "N/A"
					if (
						item.restaurant_id &&
						restaurants[item.restaurant_id] &&
						restaurants[item.restaurant_id].name
					) {
						restaurantName = restaurants[item.restaurant_id].name
					}
					return {
						id: item.id,
						name: item.name,
						description: item.description,
						price: item.price,
						restaurantName: restaurantName
					}
				})
			}
			return []
		},
		events() {
			return this.$store.state.businessEvents
				.filter((event) => {
					return event.isUpcoming
				})
				.sort((a, b) => {
					if (a.startTimestamp > b.startTimestamp) {
						return 1
					} else {
						return -1
					}
				})
		},
		slug() {
			return this.$route.params.slug
		},
		themeClass() {
			const theme = this.$route.query.theme
			if (theme == "dark") {
				return "embed-theme-dark"
			} else {
				return "embed-theme"
			}
		}
	},
	methods: {
		orderClicked() {
			window.open(`${window.location.origin}/${this.slug}`, "_blank")
			this.$store.dispatch("sendMixpanelEvent", {
				msg: "Embed Order Clicked"
			})
		},
		exploreEventsClicked() {
			window.open(
				`${window.location.origin}/${this.slug}/events`,
				"_blank"
			)
			this.$store.dispatch("sendMixpanelEvent", {
				msg: "Embed Events Clicked"
			})
		},
		comingSoonClicked() {
			window.open(`${window.location.origin}/${this.slug}`, "_blank")
			this.$store.dispatch("sendMixpanelEvent", {
				msg: "Embed Coming Soon Clicked"
			})
		}
	},
	watch: {
		loading(newVal) {
			this.toggleLoader(newVal)
		}
	}
}
</script>